export default __webpack_public_path__ + "static/media/3c.58dfcad8.png";